import { render } from "./SearchInput.vue?vue&type=template&id=13430958&scoped=true&ts=true"
import script from "./SearchInput.vue?vue&type=script&lang=ts"
export * from "./SearchInput.vue?vue&type=script&lang=ts"

import "./SearchInput.vue?vue&type=style&index=0&id=13430958&scoped=true&lang=scss"

import exportComponent from "/opt/apps/parcel4you-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13430958"]])

export default __exports__